import { useCallback, useState } from "react";

import FullScreenModal from "ds/components/FullScreenModal";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageVCS } from "hooks/useAnalytics/pages/vcs";
import { showSimpleLeaveConfirmation } from "ds/components/LeaveConfirmationModal/Simple";
import useTypedFlags from "hooks/useTypedFlags";

import useCloseFullScreenModal from "../useCloseFullScreenModal";
import VCSIntegrationsManageBitbucketCloudForm from "./Form";
import VCSIntegrationsManageBitbucketCloudFormV2 from "./FormNew";

const VCSIntegrationsManageBitbucketCloud = () => {
  const { bitbucketApiTokenSupport } = useTypedFlags();
  const [isDirty, setIsDirty] = useState(false);

  const { handleOnClose } = useCloseFullScreenModal();

  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPageVCS.VCSIntegrations,
  });

  const modalCloseClickHandler = useCallback(async () => {
    if (isDirty) {
      await showSimpleLeaveConfirmation();
    }

    handleOnClose();
    trackSegmentAnalyticsEvent("Bitbucket Cloud - Exit");
  }, [handleOnClose, trackSegmentAnalyticsEvent, isDirty]);

  const toggleIsDirty = useCallback((value: boolean) => {
    setIsDirty(value);
  }, []);

  return (
    <FullScreenModal title="Set up Bitbucket Cloud integration" onClose={modalCloseClickHandler}>
      {bitbucketApiTokenSupport ? (
        <VCSIntegrationsManageBitbucketCloudFormV2 onIsDirtyChange={toggleIsDirty} />
      ) : (
        <VCSIntegrationsManageBitbucketCloudForm onIsDirtyChange={toggleIsDirty} />
      )}
    </FullScreenModal>
  );
};

export default VCSIntegrationsManageBitbucketCloud;
